/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GoodsPackingLineVo } from './GoodsPackingLineVo';
import {
    GoodsPackingLineVoFromJSON,
    GoodsPackingLineVoFromJSONTyped,
    GoodsPackingLineVoToJSON,
    GoodsPackingLineVoToJSONTyped,
} from './GoodsPackingLineVo';
import type { PackingItemVo } from './PackingItemVo';
import {
    PackingItemVoFromJSON,
    PackingItemVoFromJSONTyped,
    PackingItemVoToJSON,
    PackingItemVoToJSONTyped,
} from './PackingItemVo';
import type { PalletGroupVo } from './PalletGroupVo';
import {
    PalletGroupVoFromJSON,
    PalletGroupVoFromJSONTyped,
    PalletGroupVoToJSON,
    PalletGroupVoToJSONTyped,
} from './PalletGroupVo';

/**
 * 
 * @export
 * @interface PackingInitResVo
 */
export interface PackingInitResVo {
    /**
     * 订单 id
     * @type {number}
     * @memberof PackingInitResVo
     */
    orderId?: number;
    /**
     * 订单可包装商品基础数据，包含未包装商品和已包装数量
     * @type {Array<GoodsPackingLineVo>}
     * @memberof PackingInitResVo
     */
    goodsForPackVOList?: Array<GoodsPackingLineVo>;
    /**
     * 箱子信息（订单下箱列表，含合包 lines、已装托托盘唛头等）
     * @type {Array<PackingItemVo>}
     * @memberof PackingInitResVo
     */
    boxes?: Array<PackingItemVo>;
    /**
     * 托盘信息（托盘头 + 已装其上的内箱列表）
     * @type {Array<PalletGroupVo>}
     * @memberof PackingInitResVo
     */
    pallets?: Array<PalletGroupVo>;
}

/**
 * Check if a given object implements the PackingInitResVo interface.
 */
export function instanceOfPackingInitResVo(value: object): value is PackingInitResVo {
    return true;
}

export function PackingInitResVoFromJSON(json: any): PackingInitResVo {
    return PackingInitResVoFromJSONTyped(json, false);
}

export function PackingInitResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PackingInitResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'goodsForPackVOList': json['goodsForPackVOList'] == null ? undefined : ((json['goodsForPackVOList'] as Array<any>).map(GoodsPackingLineVoFromJSON)),
        'boxes': json['boxes'] == null ? undefined : ((json['boxes'] as Array<any>).map(PackingItemVoFromJSON)),
        'pallets': json['pallets'] == null ? undefined : ((json['pallets'] as Array<any>).map(PalletGroupVoFromJSON)),
    };
}

export function PackingInitResVoToJSON(json: any): PackingInitResVo {
    return PackingInitResVoToJSONTyped(json, false);
}

export function PackingInitResVoToJSONTyped(value?: PackingInitResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'goodsForPackVOList': value['goodsForPackVOList'] == null ? undefined : ((value['goodsForPackVOList'] as Array<any>).map(GoodsPackingLineVoToJSON)),
        'boxes': value['boxes'] == null ? undefined : ((value['boxes'] as Array<any>).map(PackingItemVoToJSON)),
        'pallets': value['pallets'] == null ? undefined : ((value['pallets'] as Array<any>).map(PalletGroupVoToJSON)),
    };
}

